import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { environment } from '../../../../environments/environment';
import { BaseApiResponse } from '../../models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private readonly apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.identity}/Role`;

  private getRolesURL = `${this.apiURL}/getListRole`;
  private getRoleByIdURL = `${this.apiURL}/getRoleById`;
  private createRoleURL = `${this.apiURL}/createRole`;
  private updateRoleURL = `${this.apiURL}/updateRole`;
  private deleteRoleURL = `${this.apiURL}/deleteRole`;
  private getListClaimURL = `${this.apiURL}/getListClaim`;

  getRoles(
    pageIndex: number = 0,
    pageSize: number = 10,
    organizationId: string | null = null,
    name: string | null = null
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      let url = `${this.getRolesURL}?PageIndex=${pageIndex}&PageSize=${pageSize}&NeedPagination=true`;
      if (organizationId) {
        url += `&OrganizationId=${organizationId}`;
      }
      if (name) {
        url += `&Name=${encodeURIComponent(name)}`;
      }
      this.apiService.get<any>(url).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  getRoleById(id: string): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      const url = `${this.getRoleByIdURL}/${id}`;
      this.apiService.get<any>(url).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  createRole(request: any): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      this.apiService.post(this.createRoleURL, request).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  updateRole(
    id: string,
    name: string,
    claimIds: string[]
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      const request = { id, name, claimIds };
      this.apiService.post(this.updateRoleURL, request).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  deleteRole(id: string): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      const request = { id };
      this.apiService.post(this.deleteRoleURL, request).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  getListClaim(
    pageIndex: number = 0,
    pageSize: number = 200
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      const url = `${this.getListClaimURL}?PageIndex=${pageIndex}&PageSize=${pageSize}`;
      this.apiService.get<any>(url).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }
}
